var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestingServicesLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 20,
    fill: "#DB4B4A",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9590_181880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5273 39.055V24.0891L32.4961 17H23.9023C22.1765 17 20.7773 18.4106 20.7773 20.1507V39.055C20.7773 40.795 22.1765 42.2057 23.9023 42.2057H36.4023C38.1282 42.2057 39.5273 40.795 39.5273 39.055ZM32.4961 21.7261C32.4961 23.0311 33.5454 24.0891 34.8398 24.0891H37.9648V31.1782H22.3398V20.1507C22.3398 19.2807 23.0394 18.5754 23.9023 18.5754H32.4961V21.7261ZM22.3398 35.9042V32.7535H25.4648V35.9042H22.3398ZM22.3398 37.4796H25.4648V40.6303H23.9023C23.0394 40.6303 22.3398 39.925 22.3398 39.055V37.4796ZM27.0273 40.6303V37.4796H37.9648V39.055C37.9648 39.925 37.2653 40.6303 36.4023 40.6303H27.0273ZM37.9648 35.9042H27.0273V32.7535H37.9648V35.9042Z",
    fill: "#FF4B4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9590_181880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingServicesLink);
export default __webpack_public_path__ + "static/media/testing-services-link.276b483385be06ce8bd5ef5ddfa8fb85.svg";
export { ForwardRef as ReactComponent };